import { Component, forwardRef, Renderer2, ViewChild, Input, Output, OnChanges, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { HeightService } from '../../../service/height/height.service';

export const EPANDED_TEXTAREA_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SelectHeightComponent),
  multi: true,
};

@Component({
  selector: 'app-select-height',
  templateUrl: './select-height.component.html',
  styleUrls: ['./select-height.component.scss'],
  providers: [EPANDED_TEXTAREA_VALUE_ACCESSOR],
})
export class SelectHeightComponent implements ControlValueAccessor,OnChanges {
    @Input() heightId: number;
    @ViewChild('input') textarea;
    @Input() disabled: boolean;
    @Output() onMyChange = new EventEmitter();

    public heightsOptions: any[];
    public outputObject: any;

    public onChange;
    public onTouched;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;
    public query: string;
    public filters: {key: string, value: string}[];

    constructor(
        private renderer: Renderer2,
        public heightService: HeightService
    ) {
        this.page = 1;
        this.per_page = 100;
        this.query = undefined;
        this.filters = [];
        // this.filters.push({key: 'activated-lk', value: '1'});
        //this.getHeights(this.query, this.filters);
    }
    ngOnInit(){
        this.getHeights(this.query, this.filters);
    }
    ngOnChanges(){
        // this.getHeights(this.query, this.filters);//this.ngOnInit();
    }
    writeValue(value: any) {
        const div = this.textarea.nativeElement;
        // this.renderer.setProperty(div, 'textContent', value);
    }

    registerOnChange(fn: any) {
        this.onChange = fn;
    }

    registerOnTouched(fn: any) {
        this.onTouched = fn;
    }

    // setDisabledState(isDisabled: boolean ) {
    //     const div = this.textarea.nativeElement;
    //     const action = isDisabled ? 'addClass' : 'removeClass';
    //     this.renderer[action](div, 'disabled');
    // }

    setDisabledState(isDisabled: boolean) {
        this.disabled = isDisabled;
    }

    public change($event) {
        this.outputObject = this.heightsOptions.find((item) => item.id == $event.target.value);
        this.emitOutput(this.outputObject);
    }

    getHeights(query?: string, filters?: any[]) {
        this.heightService.getHeight(this.page, this.per_page, this.sort, this.query, this.filters).toPromise().then(
            response => {
                const heights = response.json().data;
                // if (response.json().meta.total > response.json().meta.total_filtered) {
                //     this.totalRecords = response.json().meta.total_filtered;
                // } else {
                //     this.totalRecords = response.json().meta.total;
                // }

                this.heightsOptions = [];
                this.heightsOptions.push({id: undefined, name: 'choose',  code_sorttime: undefined});
                heights.forEach(element => {
                    if (this.heightId == element.id) {
                        this.heightsOptions.push({id: element.id, name: element.name, selected: true, code_sorttime: element.code_sorttime});
                        this.emitOutput({id: element.id, name: element.name, selected: true, code_sorttime: element.code_sorttime});
                    } 
                    else {
                        this.heightsOptions.push({id: element.id, name: element.name, selected: false, code_sorttime: element.code_sorttime});
                    }
                });
                
            },
            error => {
                this.heightsOptions = [];
                this.heightsOptions.push({id: '', name: 'Error'});
            }
        );
    }

    public emitOutput(value: any) {   
        this.onMyChange.emit(value);
        this.onChange(value);//this.onChange = "";//
        this.onTouched(value);//this.onTouched = ""; //
    }
}


// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/heights/select-height/select-height.component.ts